var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60.5,
    r: 50,
    fill: "#EDF9F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3251 65.8236L74.491 44.4942C75.1487 43.8314 75.9858 43.5 77.0022 43.5C78.0187 43.5 78.8558 43.8314 79.5134 44.4942C80.1711 45.1569 80.5 46.0005 80.5 47.0248C80.5 48.0491 80.1711 48.8926 79.5134 49.5554L55.8363 73.4155C55.1188 74.1385 54.2818 74.5 53.3251 74.5C52.3685 74.5 51.5314 74.1385 50.8139 73.4155L41.4865 64.016C40.8288 63.3533 40.5 62.5097 40.5 61.4854C40.5 60.4611 40.8288 59.6176 41.4865 58.9548C42.1442 58.292 42.9813 57.9606 43.9978 57.9606C45.0142 57.9606 45.8513 58.292 46.509 58.9548L53.3251 65.8236Z",
    fill: "#12B76A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.f00d534fb188b2085636459c6eda8117.svg";
export { ForwardRef as ReactComponent };